import { useEffect } from 'react'
import { CardSkeleton } from '@/components/layout/card-skeleton'
import { LayoutPage } from '@/components/layout/page'
import { useIdCompany, useRBAC } from '@/lib/hooks'
import { Changelog } from '@/routes/home/changelog'
import { EmptyPage } from '@/routes/home/empty-state/empty-page'
import { RecentServices } from '@/routes/home/recent-services'
import { SpendingOverview } from '@/routes/home/spending-overview'
import * as Styled from '@/routes/home/styles'

export function Page() {
  const { idCompany } = useIdCompany()
  const { rbac, totalServices } = useRBAC()

  const {
    totalApps,
    totalDatabases,
    totalObjectStorages,
    totalStaticSites,
    totalLoadBalancers,
  } = totalServices
  const hasNoServices =
    totalApps +
      totalDatabases +
      totalObjectStorages +
      totalStaticSites +
      totalLoadBalancers ===
    0

  useEffect(() => {
    rbac.company(idCompany).apps.view.ensure()
    rbac.company(idCompany).databases.view.ensure()
    rbac.company(idCompany).objectStorages.view.ensure()
    rbac.company(idCompany).staticSites.view.ensure()
  }, [rbac, idCompany])

  return (
    <LayoutPage browserTitle="Home" fallback={<CardSkeleton />}>
      <Styled.HomeContainer>
        {/* NOTE: Company id is here to prevent a flash in loading */}
        {idCompany && hasNoServices ? (
          <EmptyPage />
        ) : (
          <>
            {rbac.company(idCompany).apps.view.can() ||
            rbac.company(idCompany).databases.view.can() ||
            rbac.company(idCompany).objectStorages.view.can() ||
            rbac.company(idCompany).staticSites.view.can() ? (
              <RecentServices />
            ) : null}
            {rbac.company(idCompany).usage.view.can() ? (
              <SpendingOverview />
            ) : null}
            <Changelog />
          </>
        )}
      </Styled.HomeContainer>
    </LayoutPage>
  )
}
